import {sessionStorageAttributesKey} from '@app/analytics/helper'

export function getQueryForCanonical<T>(objectKey: string): T | undefined {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return undefined
  }

  try {
    const storedData = sessionStorage?.getItem(sessionStorageAttributesKey)
    if (storedData) {
      const parsedData = JSON.parse(storedData)
      return parsedData?.[objectKey]
    }
  } catch (error) {
    console.error(`Error parsing sessionStorage for key "${sessionStorageAttributesKey}":`, error)
  }
  return undefined
}
